import React from 'react';
import { Button, theme } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import { CardHeader } from 'components/headings';
import { useAyuda } from './AyudaProvider';
import NovedadItem from './NovedadItem';

const MAX_EN_FEED = 3;

// Feed de novedades del inicio del admin: las últimas publicaciones de esta pantalla, con las no leídas resaltadas.
// Está pensado para el hueco bajo el calendario. "Ver todas" abre el historial en el centro de ayuda. Si no hay
// publicaciones vigentes para el inicio, no ocupa lugar.
export default function NovedadesInicio({ panelStyle }) {
  const { token } = theme.useToken();
  const { abrir, novedades } = useAyuda();
  const delInicio = novedades.vigentes.filter((p) => p.mostrarEn.includes('admin-inicio'));
  if (delInicio.length === 0) return null;

  const vistas = new Set(novedades.vistas);
  const verTutorial = (idTutorial, idNovedad) => {
    novedades.marcarLeidas([idNovedad]);
    abrir({ tutorialId: idTutorial });
  };

  return (
    <div style={panelStyle} data-testid="novedades-inicio">
      <CardHeader
        icon={NotificationOutlined}
        tint={token.colorPrimary}
        title="Novedades"
        subtitle="Lo último que se agregó a la aplicación"
        action={
          <Button type="link" size="small" onClick={() => abrir({ vista: 'novedades' })}>
            Ver todas
          </Button>
        }
      />
      <div style={{ padding: token.paddingSM, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {delInicio.slice(0, MAX_EN_FEED).map((p) => (
          <NovedadItem
            key={p.id}
            publicacion={p}
            leida={vistas.has(p.id)}
            compacta
            onVerTutorial={verTutorial}
          />
        ))}
      </div>
    </div>
  );
}
